import { PipeTransform } from '@angular/core'
import moment from 'moment'

export function generateHexId(): string {
  const id = Math.floor(Math.random() * 4096)
  return id.toString(16).padStart(3, '0').toUpperCase()
}

export function responseDefaultForm(
  type: 'string' | 'number' | 'boolean',
): string | number | boolean {
  let response: any = ''

  switch (type) {
    case 'string':
      response = ''
      break
    case 'number':
      response = 0
      break
    case 'boolean':
      response = 'T'
      break
  }
  return response
}

export function cnpjTransform(value: string): string {
  if (!value) return value

  value = value.replace(/\D/g, '')
  if (value.length <= 2) return value
  if (value.length <= 5) return value.replace(/(\d{2})(\d{0,3})/, '$1.$2')
  if (value.length <= 8)
    return value.replace(/(\d{2})(\d{3})(\d{0,3})/, '$1.$2.$3')
  if (value.length <= 12)
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{0,4})/, '$1.$2.$3/$4')
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
}

export function cpfTransform(value: string): string {
  if (!value) return value

  value = value.replace(/\D/g, '')
  if (value.length <= 3) return value
  if (value.length <= 6) return value.replace(/(\d{3})(\d{0,3})/, '$1.$2')
  if (value.length <= 9)
    return value.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3')
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4')
}

export function phoneTransform(value: string): string {
  if (!value) return value

  value = value.replace(/\D/g, '') // Remove tudo o que não for número
  if (value.length <= 10) {
    return value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3') // Formato (XX) XXXX-XXXX
  } else if (value.length === 11) {
    return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') // Formato (XX) XXXXX-XXXX
  }
  return value
}

export function removeAccents(string: string): string {
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export function removeAccentsAndSpacesAndLowercase(string: string): string {
  return string
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s/g, '')
    .toLowerCase()
}

export function validTreatList(response: any): boolean {
  if (response && response.statusCode == 200 && response.data.length > 0) {
    return true
  } else {
    return false
  }
}

export function convertCurrency(value: any): string | number {
  let currency: any = ''
  if (typeof value == 'string') {
    currency = parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
  } else if (typeof value == 'number') {
    currency = value.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }

  return currency
}

export function formatDateForm(dateValue: any): string {
  if (!dateValue) {
    return ''
  }

  const momentDate = moment(dateValue)

  if (momentDate.isValid()) {
    return momentDate.format('DD/MM/YYYY')
  }

  return ''
}
